/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Integration_Prohibited_DescInputs */



/**
* | output |
* | --- |
* | "The {integration} integration was prohibited for the organisation. Existing connections keep their data and credentials; only its use is refused." |
*
* @param {Audit_Details_Integration_Prohibited_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_prohibited_desc = /** @type {((inputs: Audit_Details_Integration_Prohibited_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Prohibited_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Integration ${i?.integration} wurde für die Organisation gesperrt. Bestehende Verbindungen behalten Daten und Zugangsdaten; nur die Nutzung wird verweigert.`)
	return /** @type {LocalizedString} */ (`The ${i?.integration} integration was prohibited for the organisation. Existing connections keep their data and credentials; only its use is refused.`)
});